class ScrollBar extends HTMLElement {
  constructor() {
    super();
    this.hideScrollbarTimeout = null;
    this.isDesktop = window.innerWidth > 1024;

    if (this.isDesktop) {
      this.initScrollbar();
    }
  }

  connectedCallback() {
    if (this.isDesktop) {
      this.setupResizeHandler();
      this.setupAnchorLinks();
      window.addEventListener("scroll", () => this.showScrollbarTemporarily());
    }
  }

  showScrollbarTemporarily() {
    document.documentElement.classList.add("show-scrollbar");
    clearTimeout(this.hideScrollbarTimeout);
    this.hideScrollbarTimeout = setTimeout(() => {
      document.documentElement.classList.remove("show-scrollbar");
    }, 100);
  }

  initScrollbar() {
    const track = this.querySelector(".inner");
    const thumb = this.querySelector(".thumb");

    const calculateDimensions = () => {
      const trackHeight = track.offsetHeight;
      const thumbHeight = Math.max((window.innerHeight / document.documentElement.scrollHeight) * trackHeight, 30); // Tamanho mínimo do thumb
      thumb.style.height = `${thumbHeight}px`;
      return { trackHeight, thumbHeight };
    };

    let { trackHeight, thumbHeight } = calculateDimensions();

    const updateThumbPosition = () => {
      const scrollPos = window.scrollY;
      const scrollLimit = document.documentElement.scrollHeight - window.innerHeight;
      const scrollableDistance = trackHeight - thumbHeight;
      const thumbTop = (scrollPos / scrollLimit) * scrollableDistance;
      thumb.style.transform = `translate3d(0, ${thumbTop}px, 0)`;
    };

    const updateDimensions = () => {
      ({ trackHeight, thumbHeight } = calculateDimensions());
      updateThumbPosition();
    };

    window.addEventListener("resize", updateDimensions);
    window.addEventListener("scroll", updateThumbPosition);

    // Adiciona suporte ao drag do thumb
    let startY = null;

    const onPointerMove = (e) => {
      if (!startY) return;
      e.preventDefault();
      const deltaY = e.clientY - startY;
      const scrollableDistance = trackHeight - thumbHeight;
      const scrollPos = Math.min(
        Math.max(0, (deltaY / scrollableDistance) * (document.documentElement.scrollHeight - window.innerHeight)),
        document.documentElement.scrollHeight - window.innerHeight
      );
      window.scrollTo(0, scrollPos);
    };

    const onPointerDown = (e) => {
      startY = e.clientY - thumb.getBoundingClientRect().top;
      thumb.classList.add("grabbing");
    };

    const onPointerUp = () => {
      startY = null;
      thumb.classList.remove("grabbing");
    };

    thumb.addEventListener("pointerdown", onPointerDown);
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onPointerUp);

    updateThumbPosition(); // Atualiza a posição inicial do thumb
  }

  setupResizeHandler() {
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const wasDesktop = this.isDesktop;
        this.isDesktop = window.innerWidth > 1024;
        if (wasDesktop !== this.isDesktop) {
          if (this.isDesktop) {
            this.initScrollbar();
            this.setupAnchorLinks();
          } else {
            window.removeEventListener("scroll", this.showScrollbarTemporarily);
          }
        }
      }, 150);
    });
  }

  setupAnchorLinks() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  }
}

customElements.define("scroll-bar", ScrollBar);